<template>
  <PageScrollbar ref="scrollbarRef" class="page-home-root" @ps-scroll-y="onPsScroll">
    <!-- <div class="scroll-indicator "></div> -->
    <header class="layout-navbar">
      <div class="navbar-content-container w-full">
        <header-navigation class="m-0" />
      </div>
    </header>
    <!-- 第一屏：视频 -->
    <section class="hero-section relative w-100vw h-100vh max-ml:h-auto" ref="hero">
      <!-- isOrigin -->
      <PageContentCenter v-if="isVideo(firstScreenItem.mediaUrl)"
        class="ml:p-0! ml:h-100vh lg:w-100vw! max-ml:h-auto! max-ml:px-1rem! max-ml:pt-1rem">
        <!-- 因为时间问题，不解决样式了，第一版上线了要，直接根据设备判断了 -->
        <VideoPlayerMobile v-if="isMobile" :src="firstScreenItem.mediaUrl" :videoAttrs="{
        }"
          class="w-100% ml:h-100vh! max-ml:object-cover max-ml:rounded-2 max-ml:overflow-hidden max-ml:object-center max-ml:h-auto" />
        <VideoPlayerPc v-else :src="firstScreenItem.mediaUrl" :videoAttrs="{
          playsinline: true,
          'webkit-playsinline': true,
          'x5-playsinline': true,
          'x-webkit-airplay': 'allow',
          controls: isWechat,
          autoplay: !isWechat,
          muted: true,
          loop: !isWechat,
          poster: firstScreenItem.poster
        }" :isOrigin="firstScreenItem.isOrigin"
          class="w-100% ml:h-100vh! max-ml:object-cover max-ml:rounded-2 max-ml:overflow-hidden max-ml:object-center max-ml:h-auto" />
      </PageContentCenter>

      <Pic v-else :src="firstScreenItem.mediaUrl" :alt="firstScreenItem.title" :title="firstScreenItem.title"
        class="relative z-0 w-100vw h-100vh object-center block " />
      <PageContentCenter v-if="!isVideo(firstScreenItem.mediaUrl)" :style="{ color: firstScreenItem.fontColor }"
        class="absolute z-10 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
        <h2 class="section-title text-13.5 mb-6 text-inherit max-ml:px-6 font-600">{{ firstScreenItem.title }}</h2>
        <p class="section-description text-5.5 mb-17.5 max-ml:px-6  font-200">{{ firstScreenItem.description }}</p>
        <nuxt-link class="text-4 section-link flex opacity-20 font-200" external>
          <span>了解详情</span>
          <Pic src="/images/pages/home/w-l.png" class="w-1rem h-1rem relative left-4" />
        </nuxt-link>
      </PageContentCenter>
    </section>


    <!-- 以下内容正常滚动 -->
    <section v-for="(item, index) in sectionItems" :key="index"
      class="normal-section relative h-100vh w-100vw max-ml:hidden!" :style="{ color: item.fontColor }">
      <Pic
        class="relative z-0 top-0 w-100vw h-100vh object-fill max-ml:object-cover max-ml:object-center max-ml:w-100% max-ml:h-auto"
        :src="item.backgroundImage" :alt="item.title" :title="item.title" />
      <PageContentCenter v-fade-up
        class="absolute! z-1 max-ml:right-auto! max-ml:top-auto! max-ml:text-left! max-ml:scale-[0.5]! max-ml:left-[-20%]!"
        :style="item.extraCopywritingStyle ?? {}">
        <h2 class="section-title text-inherit mb-6 font-600">{{ item.title }}</h2>
        <p class="section-description mb-6  font-200" v-html="item.description"></p>
        <ul class="flex" v-if="item.descItems && item.descItems.length > 0">
          <li v-for="descItem in item.descItems" :key="descItem.desc" class="flex mr-3.25rem">
            <Pic class="w-1.88rem h-1.88rem mr-0.5rem" :src="descItem.icon" :alt="descItem.desc"
              :title="descItem.desc" />
            <span class="ml-8px text-13px leading-1.88rem">{{ descItem.desc }}</span>
          </li>
        </ul>
        <nuxt-link :to="item.link" class="text-4 section-link flex mt-17.5  font-200 inline-block! w-300px" external>
          <span>了解详情</span>
          <Pic v-if="item.fontColor.startsWith('#fff')" src="/images/pages/home/w-l.png"
            class="inline w-1rem h-1rem relative  m-l-2  top-1px" />
          <Pic v-else src="/images/pages/home/b-l.png" class="inline w-1rem h-1rem relative m-l-2 top-1px " />
        </nuxt-link>
      </PageContentCenter>
    </section>

    <PageContentCenter class="p-1rem! hidden max-ml:block min-h-[100vh]">
      <section v-for="homeItem in sectionItems" class="mb-1rem last:mb-0">
        <nuxt-link :to="homeItem.link">
          <Pic :src="homeItem.mobileBackgroundImage" class="w-100%"></Pic>
        </nuxt-link>
      </section>
    </PageContentCenter>
    <SiteMap />

    <!-- 👉 Footer -->

    <footer-certificate class="max-ml:pb-7rem" />
    <MouseScrolling />
  </PageScrollbar>
</template>

<script setup lang="ts">
import { ref, nextTick, onMounted, onUnmounted } from 'vue'
// import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
const { isMobile } = useDevice()
import { useSeoMeta } from 'nuxt/app'
import VideoPlayerPc from '../components/media/VideoPlayerPc.vue'
function isWechatFn() {
  if (typeof navigator === 'undefined') return false
  return /MicroMessenger/i.test(navigator.userAgent)
}
const isWechat = isWechatFn()

// 指定使用 blank 布局
definePageMeta({
  layout: 'blank',
})

// 设置页面SEO元信息
useSeoMeta({
  title: '首页',
  description: '湖南和贵网络科技官方网站',
})

// 判断是图片还是视频
const isVideo = (item: any) => {
  return item.endsWith('.mp4') || item.endsWith('.m3u8') || item.endsWith('.webm')
}
const firstScreenItem = ref(
  {
    title: '即时榔',
    description: '重构快消零售  激活场景价值',
    backgroundImage: '/videos-clipped/hg-introduction-video/playlist.webm',
    poster: '/images/mobile/poster-time.png',
    // mediaUrl: 'https://hctxgw-dev.feimawaiqin.com:9797/videos-clipped/hg-introduction-video/playlist.m3u8',
    mediaUrl: '/videos/hg-introduction-video.webm',
    fontColor: '#102136',
    isOrigin: true // 是否原始视频 还是m3u8
  }
)
const sectionItems = ref([
  {
    title: 'DMS经销渠道管理平台',
    description: '助力品牌商实现全渠道&全场景业务管理闭环',
    backgroundImage: '/images/pages/home/dms-1.png',
    mobileBackgroundImage: '/images/mobile/home/dms.png',
    fontColor: '#fff',
    link: '/products/dms'
  },
  {
    title: '飞马外勤',
    description: '智能外勤管理解决系统',
    backgroundImage: '/images/pages/home/feima-1.png',
    mobileBackgroundImage: '/images/mobile/home/feima.png',
    fontColor: '#173357',
    link: '/products/feima',
    descItems: [{
      icon: '/images/pages/home/home_fm_icon@2x (1).png',
      desc: '数据驱动'
    }, {
      icon: '/images/pages/home/home_fm_icon@2x (2).png',
      desc: '即时协同'
    }, {
      icon: '/images/pages/home/home_fm_icon@2x (3).png',
      desc: '实时监管'
    }, {
      icon: '/images/pages/home/home_fm_icon@2x (4).png',
      desc: '智能分析'
    }]
  },
  {
    title: '即时榔',
    description: '重构快消零售  激活场景价值',
    backgroundImage: '/images/pages/home/jsl-1.png',
    mobileBackgroundImage: '/images/mobile/home/jsl.png',
    fontColor: '#102136',
    link: '/products/jsl'
  },
  {
    title: '会员积分兑换商城',
    description: '聚焦垂直品类的场景化会员互动 <br /> 与价值运营平台',
    backgroundImage: '/images/pages/home/hyjfsc-1.png',
    mobileBackgroundImage: '/images/mobile/home/points_mall.png',
    fontColor: '#fff',
    extraCopywritingStyle: {
      right: '34%',
      top: '14%',
      textAlign: 'right'
    },
    link: '/products/redemption-center'
  },

])

const scrollbarRef = ref<any>(null)
const heroRef = ref<HTMLElement | null>(null)

const scrollingLock = ref(false)

let wheelHandler: (e: WheelEvent) => void


// 保留但不用于吸附（避免频繁触发吸附逻辑）
const onPsScroll = () => {
  // 可以在这里做一些 UI 更新（比如隐藏 scroll-tip），但不要触发吸附
  // 如果你想，scroll-tip 在用户开始滚动时可以淡出
  // 示例（可选）:
  // const container = scrollbarRef.value?.$el
  // if (container && container.scrollTop > 10) { hideTip() }
}

const addTrace = () => {
  // 给首页加埋点脚本
  const script = document.createElement('script')
  script.setAttribute("trace", "true")
  script.innerHTML = `!(function(c,b,d,a){c[a]||(c[a]={});c[a]={pid:'fbd7jmivcn@47010d8c836b27d',endpoint:'https://fbd7jmivcn-default-cn.rum.aliyuncs.com',env:'${process.env.APP_ENV}',spaMode:'history',collectors:{perf:!0,webVitals:!0,api:!0,staticResource:!0,jsError:!0,consoleError:!0,action:!0},tracing:!1};with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)})(window,document,"https://sdk.rum.aliyuncs.com/v2/browser-sdk.js","__rum");`
  document.body.appendChild(script)
}
onMounted(async () => {
  await nextTick()
  const root = scrollbarRef.value?.$el as HTMLElement
  heroRef.value = root?.querySelector('.hero-section') ?? null

  wheelHandler = (e: WheelEvent) => {

    const container = scrollbarRef.value?.$el as HTMLElement
    if (!container) return
    if (scrollingLock.value) return

    const delta = e.deltaY
    const scrollTop = container.scrollTop
    const screenHeight = window.innerHeight
    const DOWN_THRESHOLD = 30
    const UP_THRESHOLD = -30

    // 取当前所在屏（四舍五入到最近整屏）
    const currentScreen = Math.round(scrollTop / screenHeight)

    if (delta > DOWN_THRESHOLD) {
      e.preventDefault()
      const nextScreen = currentScreen + 1
      const target = nextScreen * screenHeight
      scrollToSmooth(container, target, 600)
      return
    }

    if (delta < UP_THRESHOLD) {
      e.preventDefault()
      const prevScreen = Math.max(currentScreen - 1, 0)
      const target = prevScreen * screenHeight
      scrollToSmooth(container, target, 600)
      return
    }
  }

  // 给滚动容器注册 wheel（useCapture=false, passive=false 使 preventDefault 有效）
  root?.addEventListener('wheel', wheelHandler, { passive: false })

  addTrace()
})

onUnmounted(() => {
  const root = scrollbarRef.value?.$el as HTMLElement
  if (root && wheelHandler) root.removeEventListener('wheel', wheelHandler)
})

/** 平滑滚动（返回 Promise 可用于链式逻辑） */
const scrollToSmooth = (container: HTMLElement, target: number, duration = 600) => {
  scrollingLock.value = true
  return new Promise<void>((resolve) => {
    const start = container.scrollTop
    const distance = target - start
    const startTime = performance.now()

    const animate = (now: number) => {
      const progress = Math.min((now - startTime) / duration, 1)
      const ease = 0.5 * (1 - Math.cos(Math.PI * progress)) // easeInOut
      container.scrollTop = start + distance * ease
      if (progress < 1) {
        requestAnimationFrame(animate)
      } else {
        // 小延迟确保滚动稳定
        setTimeout(() => {
          scrollingLock.value = false
          resolve()
        }, 50)
      }
    }

    requestAnimationFrame(animate)
  })
}
</script>

<style lang="scss" scoped>
@import "@base/@core/scss/template/libs/vuetify/variables";

.page-home-root {
  width: 100vw;
  height: 100vh;
}

.hero-section {
  position: relative;
  width: 100vw;
  max-width: $page-max-width;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }
}

/* normal sections 使用 min-height 保持至少一屏高，但允许内容超过一屏自然滚动 */
.normal-section {
  display: flex;
  width: 100%;
  max-width: $page-max-width;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
</style>
